import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { update, get, setTitle, getAll } from '../../actions'
import Card from '../../components/Card'
import Input from '../../components/Input'
import Button from '../../components/Button'
import styled from 'styled-components'

const CreateSupplier = props => {
  const [passwordVerify, setPasswordVerify] = useState(false)
  const [password, setPassword] = useState('')
  const [form, setForm] = useState({})
  const { setTitle, user, branch } = props
  const { id } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    const topbar = {
      title: 'Editar Usuario',
    }
    setTitle(topbar)
    props.get(`users/${id}`, 'GET_USER').then(() => {
      props.getAll('branch', 'GET_BRANCH')
    })

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (user) {
      setForm({
        user: user.user,
        password: '',
        nss: user.nss,
        rfc: user.rfc,
        curp: user.curp,
        name: user.name,
        lastname: user.lastname,
        lastname2: user.lastname2,
        position: user.position,
        department: user.department,
        branch_id: user.branch_id,
        role: user.role,
        auto: user.auto,
      })
    }
    // eslint-disable-next-line
  }, [user])

  const handlePasswordVerify = e => {
    if (password === e.target.value) {
      setPasswordVerify(true)
    } else {
      setPasswordVerify(false)
    }
  }

  const handleForm = e => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    props.update(`users/${id}`, 'POST_USER', form).then(() => {
      navigate('/users')
    })
  }
  if (user) {
    return (
      <Card title={'Información del usuario'}>
        <form id="formUser" onSubmit={e => handleSubmit(e)}>
          <Input
            type="text"
            name="nss"
            title="N.S.S"
            onChange={e => handleForm(e)}
            defaultValue={user.nss}
          />
          <Input
            type="text"
            name="rfc"
            title="RFC"
            onChange={e => handleForm(e)}
            defaultValue={user.rfc}
          />
          <Input
            type="text"
            name="curp"
            title="CURP"
            onChange={e => handleForm(e)}
            defaultValue={user.curp}
          />
          <Input
            type="text"
            name="lastname"
            title="Apellido Paterno"
            onChange={e => handleForm(e)}
            defaultValue={user.lastname}
          />
          <Input
            type="text"
            name="lastname2"
            title="Apellido Materno"
            onChange={e => handleForm(e)}
            defaultValue={user.lastname2}
          />
          <Input
            type="text"
            name="name"
            title="Nombre"
            onChange={e => handleForm(e)}
            defaultValue={user.name}
          />
          <Input
            type="text"
            name="position"
            title="Puesto"
            onChange={e => handleForm(e)}
            defaultValue={user.position}
          />
          <Input
            type="text"
            name="department"
            title="Departamento"
            onChange={e => handleForm(e)}
            defaultValue={user.department}
          />
          <Input
            type="text"
            name="user"
            title="Usuario"
            onChange={e => handleForm(e)}
            defaultValue={user.user}
          />
          <Input
            type="password"
            name="password"
            title="Contraseña"
            onChange={e => {
              handleForm(e)
              setPassword(e.target.value)
            }}
          />
          <Input
            type="password"
            name="confirmPassword"
            title="Confirmar Contraseña"
            onChange={e => {
              handlePasswordVerify(e)
            }}
          />

          {password !== '' ? (
            passwordVerify ? (
              <Span pass={passwordVerify}>Password Correcto</Span>
            ) : (
              <Span pass={passwordVerify}>
                Los password deben ser iguales
              </Span>
            )
          ) : null}

          <Select
            onChange={e => handleForm(e)}
            name="branch_id"
            required
          >
            <option value={user.branch_id}>
              Seleccione una sucursal
            </option>
            {branch.map(b => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </Select>

          <Select onChange={e => handleForm(e)} name="role" required>
            <option value={user.role}>Seleccione una rol</option>
            <option value="1">Administrador</option>
            <option value="2">Usuario</option>
          </Select>

          {parseInt(user.role) === 0 ? (
            <Select
              onChange={e => handleForm(e)}
              name="auto"
              required
            >
              <option value={user.auto}>
                Seleccione un automatizador
              </option>
              <option value="0">No</option>

              <option value="1">Si</option>
            </Select>
          ) : null}

          <BarButton>
            <Button type="submit" color="success">
              Editar
            </Button>
            <Link to="/users">
              <Button className="btn --danger">Cancelar</Button>
            </Link>
          </BarButton>
        </form>
      </Card>
    )
  } else {
    return <h1>Cargando</h1>
  }
}

const mapStateToProps = state => {
  return {
    branch: state.branch.branch,
    user: state.users.user,
    themeApp: state.reducerApp.themeApp,
    localization: state.reducerApp.localization,
  }
}

const mapDispatchToProps = {
  update,
  get,
  setTitle,
  getAll,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateSupplier)

const Select = styled.select`
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  outline-color: ${({ theme }) => theme.border};
  color: var(--dark);
  background-color: var(--white);
  background-clip: padding-box;
  border-radius: 3px;
  border: ${({ theme }) => theme.border};
  box-shadow: none;
  margin-top: 0.375rem;
  border-style: solid;
  border-radius: 7px;
  width: 100%;
  transition: border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
`

const BarButton = styled.div`
  margin-top: 1rem;
`

const Span = styled.span`
  color: ${props =>
    props.pass ? props.theme.success : props.theme.danger};
  font-size: 0.875rem;
  line-height: 2.5;
`
